var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23775 6.66349C9.07466 6.66349 10.5695 5.16865 10.5695 3.33175C10.5695 1.49484 9.07466 0 7.23775 0C5.40085 0 3.90601 1.49484 3.90601 3.33175C3.90601 5.16865 5.40085 6.66349 7.23775 6.66349ZM7.23775 1.48078C8.25875 1.48078 9.08872 2.31075 9.08872 3.33175C9.08872 4.35274 8.25875 5.18272 7.23775 5.18272C6.2175 5.18272 5.38678 4.35274 5.38678 3.33175C5.38678 2.31075 6.2175 1.48078 7.23775 1.48078Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4598 13.0947C13.6897 9.7037 10.7201 7.33594 7.23875 7.33594C3.7567 7.33594 0.787743 9.70444 0.01848 13.0947C-0.0718473 13.4937 0.177664 13.8906 0.576733 13.9809C0.974321 14.0698 1.37191 13.821 1.46224 13.4227C2.0775 10.7114 4.45266 8.81671 7.23875 8.81671C10.0241 8.81671 12.4 10.7114 13.0153 13.4234C13.093 13.767 13.3988 13.9994 13.7364 13.9994C13.7904 13.9994 13.8452 13.9935 13.9015 13.9817C14.2998 13.8906 14.5501 13.4937 14.4598 13.0947Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestIcon);
export default __webpack_public_path__ + "static/media/guest_icon.5a7bbdcd4def160b077944e57c2cc150.svg";
export { ForwardRef as ReactComponent };